import { ReferenceDataOptionLists } from '../../constants/reference-data-option-lists';
import { Deserializable } from '../deserializable';

export class CaseSetupDto implements Deserializable {
  public IsApplication: boolean;
  public NumberOfApplicants: number;
  public Forename: string;
  public Surname: string;
  public ContactNumber: string;
  public EmailAddress: string;
  public ThisIs: string;
  public PropertyLocation: string;
  public SelectionTypeCode: string;
  public InterfaceTypeID: number;
  public PropositionID: number;
  public UserID: number;
  public BranchID: number;
  public ReferringBranch: string;
  public ReferringIndividual: string;
  public MarketingReference: string;
  public EligibilityInterestOnlyAnswerCode: string;
  public WhereDidUserHearAboutProduct: number;
  public CaseType: string;
  public CaseStatus: string;
  public IsRemortgage: string;
  public IsHelpToBuy: string;
  public IsNichaApplication: string;
  public Order: number;

  public IsBankOfIrelandProposition: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }

  public canBeNichaApplication(): boolean {
    return (
      this.IsHelpToBuy === ReferenceDataOptionLists.AnswerTypeYes &&
      this.PropertyLocation === ReferenceDataOptionLists.PropertyLocationNorthernIreland &&
      this.IsBankOfIrelandProposition
    );
  }
}
